
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[...categories]",
      function () {
        return require("private-next-pages/shop/[...categories].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/[...categories]"])
      });
    }
  